import planesFormModel from './planesFormModel';
import { currencies } from 'commons/constants/currencies';

const {
    formField: {
        name,
        description,
        monthlyPrice,
        currency,
        monthlyCredits,
        durationDays,
        maxRequestsDay,
        maxRequestsMonth,
        maxAssistants,
        maxAgents,
        maxUsers,
        allowChat,
        allowImages,
        allowAudio,
        allowDocuments,
        allowEmbeddings,
        allowMemory,
        allowTools,
        allowRag,
        sortOrder
    }
} = planesFormModel;

export default {
    [name.name]: '',
    [description.name]: '',
    [monthlyPrice.name]: '',
    [currency.name]: currencies.find(c => c.value === 'USD'),
    [monthlyCredits.name]: '',
    [durationDays.name]: '',
    [maxRequestsDay.name]: '',
    [maxRequestsMonth.name]: '',
    [maxAssistants.name]: '',
    [maxAgents.name]: '',
    [maxUsers.name]: '',
    [allowChat.name]: false,
    [allowImages.name]: false,
    [allowAudio.name]: false,
    [allowDocuments.name]: false,
    [allowEmbeddings.name]: false,
    [allowMemory.name]: false,
    [allowTools.name]: false,
    [allowRag.name]: false,
    [sortOrder.name]: ''
};
